import { Component, Input } from "@angular/core";

import { CustomModal } from "../base-modals/custom-modal";

@Component({
	templateUrl: "./confirm-modal.component.html",
	standalone: false
})
export class ConfirmModalComponent extends CustomModal {
	@Input() public titleKey: string = "close_window?";
	@Input() public buttonYesKey: string = "modal_confirm_yes_option";
	@Input() public buttonNoKey: string = "modal_confirm_no_option";

	public answer(b: boolean): void {
		this.close(b, b ? "confirm" : "cancel");
	}
}
